import React from 'react';

interface IconBookProps {
    className?: string;
}

const IconBook: React.FC<IconBookProps> = ({ className }) => {
    return (
        <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M19.5 3.25H6.49998C5.30336 3.25 4.33331 4.22005 4.33331 5.41667V20.5833C4.33331 21.78 5.30336 22.75 6.49998 22.75H19.5C20.6966 22.75 21.6666 21.78 21.6666 20.5833V5.41667C21.6666 4.22005 20.6966 3.25 19.5 3.25Z"
                fill="currentColor"
            />
            <path
                d="M9.20831 7.0415H16.7916M9.20831 10.2915H13.5416M9.20831 13.5415H15.7083"
                stroke="#0B0B0B"
                strokeWidth="1.08333"
                strokeLinecap="round"
            />
            <path
                d="M4.33331 20.5832C4.33331 20.0085 4.56159 19.4574 4.96791 19.0511C5.37424 18.6448 5.92534 18.4165 6.49998 18.4165H18.4166C19.4263 18.4165 19.9311 18.4165 20.3287 18.2518C20.5918 18.1429 20.8308 17.9833 21.0321 17.782C21.2334 17.5807 21.3931 17.3416 21.502 17.0786C21.6666 16.681 21.6666 16.1762 21.6666 15.1665V18.4165C21.6666 20.4597 21.6666 21.4802 21.0318 22.115C20.397 22.7498 19.3765 22.7498 17.3333 22.7498H6.49998C5.92534 22.7498 5.37424 22.5216 4.96791 22.1152C4.56159 21.7089 4.33331 21.1578 4.33331 20.5832Z"
                fill="#9D9D9D"
            />
        </svg>
    );
};

export default IconBook;